export default __webpack_public_path__ + "img/question-circle.16b86cd2.png";